import { render, staticRenderFns } from "./Requisites.vue?vue&type=template&id=3da41270&scoped=true&"
import script from "./Requisites.vue?vue&type=script&lang=ts&"
export * from "./Requisites.vue?vue&type=script&lang=ts&"
import style0 from "./Requisites.vue?vue&type=style&index=0&id=3da41270&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da41270",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VCard,VCol,VExpandTransition,VRow,VSkeletonLoader,VSwitch})
